import { Injectable, inject } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import soliticsconfig from "@config/soliticsconfig";
import { SoliticsEventName } from "@constants";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { NewBaseService } from "@providers/newBase.service";
import { Utils } from "@shared-utils/Utils";
import { Solitics as SoliticsCapacitor, SoliticsEvent, SoliticsUser } from "@solitics/capacitor";

declare var $solitics: Solitics;
export abstract class Solitics {
  loginSuccess: Function;
  onLogout: Function;
  onPageEnter: Function;
  emit: Function;
}

@Injectable({
  providedIn: "root",
})
export class SoliticsService {
  private globalVars: GlobalVarsModel;
  private baseService = inject(NewBaseService);
  private utils = inject(Utils);

  constructor() {
    this.baseService.getVars.subscribe((data) => {
      this.globalVars = data;
    });
  }

  async login() {
    if (!this.globalVars.FEATURES.EnabledSolitics) {
      return;
    }
    const user = this.globalVars.user;

    const soliticsUser = {
      email: user.email,
      keyType: "username",
      keyValue: user.username,
      popupToken: soliticsconfig[this.globalVars.licenseType].insights.solitics.token,
      brand: soliticsconfig[this.globalVars.licenseType].insights.solitics.brand,
      memberId: user.id,
    };

    if (Capacitor.isNativePlatform() && this.utils.isPluginAvailable("SoliticsBridge")) {
      await SoliticsCapacitor.instance.onLogin(new SoliticsUser(soliticsUser));
    } else {
      $solitics.loginSuccess(soliticsUser);
    }

    const payload: Record<string, string | number> = {
      deviceOperatingSystem: this.globalVars.DEVICE_TYPE,
      email: user.email,
      memberId: user.id,
    };

    if (user.balance) {
      payload.userBalance = user.balance;
    }
    const l = location.href.split("#");

    if (l[1]) {
      payload.eventProductTab = l[1];
    }

    this.emitEvent(SoliticsEventName.LOGIN, JSON.stringify(payload), user.balance);
  }

  logout() {
    if (!this.globalVars.FEATURES.EnabledSolitics) {
      return;
    }
    if (Capacitor.isNativePlatform() && this.utils.isPluginAvailable("SoliticsBridge")) {
      SoliticsCapacitor.instance.onLogout();
    } else {
      $solitics.onLogout();
    }
  }

  betCompleted(payload: {
    betType: string;
    currency: string;
    amount: number;
    odd: string;
  }) {
    this.emitEvent(SoliticsEventName.BET_COMPLETED, JSON.stringify(payload), payload.amount);
  }

  gameLaunched(payload: { name: string; type: string }) {
    this.emitEvent(SoliticsEventName.GAME_LAUNCHED, JSON.stringify(payload));
  }

  private emitEvent(eventName: string, payload: string, amount?: number) {
    if (!this.globalVars.FEATURES.EnabledSolitics || !this.globalVars.user.logged) {
      return;
    }
    if (Capacitor.isNativePlatform() && this.utils.isPluginAvailable("SoliticsBridge")) {
      const event = new SoliticsEvent({
        name: eventName,
        amount: amount ?? 0.0,
        fields: payload,
      });

      SoliticsCapacitor.instance.emitEvent(event);
    } else {
      $solitics.emit(eventName, null, payload);
    }
  }
}
